/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const MarkLight = (
	<SVG
		viewBox="0 0 179 179"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="pum-icon  pum-icon--mark-light  pum-mark  pum-mark--light"
	>
		<Path
			d="M123.791 119.031C126.05 116.426 127.485 113.209 127.916 109.788C128.347 106.366 127.753 102.894 126.21 99.81L106.595 60.583C105.147 57.6875 102.921 55.2525 100.167 53.5506C97.413 51.8488 94.2394 50.9474 91.0018 50.9474C87.7643 50.9474 84.5907 51.8488 81.8365 53.5506C79.0824 55.2525 76.8565 57.6875 75.4083 60.583L55.7937 99.81C54.2482 102.895 53.653 106.37 54.0835 109.794C54.5141 113.217 55.951 116.436 58.2123 119.043C60.4737 121.649 63.4577 123.526 66.7866 124.436C70.1154 125.346 73.6393 125.247 76.9121 124.153L91.0999 119.445L105.201 124.131C108.457 125.203 111.958 125.291 115.265 124.384C118.571 123.477 121.537 121.615 123.791 119.031V119.031ZM91.0999 68.3848L110.714 107.612L95.9164 102.687C92.7897 101.646 89.4102 101.646 86.2835 102.687L71.4854 107.612L91.0999 68.3848Z"
			fill="white"
		/>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M58.5769 25.4737C39.3922 25.4737 23.84 41.026 23.84 60.2106V64.8422C23.84 71.237 18.656 76.4211 12.2611 76.4211C5.8662 76.4211 0.682129 71.237 0.682129 64.8422L0.682129 60.2106C0.682129 28.2362 26.6025 2.31584 58.5769 2.31584L65.5242 2.31584C71.9191 2.31584 77.1032 7.49991 77.1032 13.8948C77.1032 20.2897 71.9191 25.4737 65.5242 25.4737H58.5769Z"
			fill="#1DBE61"
		/>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M58.5769 155.158C39.3922 155.158 23.84 139.606 23.84 120.421V115.79C23.84 109.395 18.656 104.211 12.2611 104.211C5.8662 104.211 0.682129 109.395 0.682129 115.79L0.682129 120.421C0.682129 152.395 26.6025 178.316 58.5769 178.316H65.5242C71.9191 178.316 77.1032 173.132 77.1032 166.737C77.1032 160.342 71.9191 155.158 65.5242 155.158H58.5769Z"
			fill="#1DBE61"
		/>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M121.103 25.4737C140.288 25.4737 155.84 41.026 155.84 60.2106V64.8422C155.84 71.237 161.024 76.4211 167.419 76.4211C173.814 76.4211 178.998 71.237 178.998 64.8422V60.2106C178.998 28.2362 153.078 2.31584 121.103 2.31584L114.156 2.31584C107.761 2.31584 102.577 7.49991 102.577 13.8948C102.577 20.2897 107.761 25.4737 114.156 25.4737H121.103Z"
			fill="#1DBE61"
		/>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M121.103 155.158C140.288 155.158 155.84 139.606 155.84 120.421V115.79C155.84 109.395 161.024 104.211 167.419 104.211C173.814 104.211 178.998 109.395 178.998 115.79V120.421C178.998 152.395 153.078 178.316 121.103 178.316H114.156C107.761 178.316 102.577 173.132 102.577 166.737C102.577 160.342 107.761 155.158 114.156 155.158H121.103Z"
			fill="#1DBE61"
		/>
	</SVG>
);

export default MarkLight;
